'use es6';
/**
 * @see {@link https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/designfolders/FolderSubcategory.java}
 */

export const DESIGN_ROOT = 1;
export const THEME = 2;
export const DESIGN_IMAGE = 3;
export const DESIGN_CSS = 4;
export const DESIGN_JS = 5;
export const DESIGN_MODULE = 6;
export const DESIGN_CUSTOM_MODULE = 7;
export const DESIGN_GLOBAL_MODULE = 8;
export const DESIGN_GLOBAL_GROUP = 9;
export const DESIGN_TEMPLATE = 10;
export const DESIGN_BLOG_TEMPLATE = 11;
export const DESIGN_EMAIL_TEMPLATE = 12;
export const DESIGN_PAGE_TEMPLATE = 13;
export const DESIGN_SYSTEM_TEMPLATE = 14;
export const DESIGN_DEFAULT_MODULE = 15;
export const DESIGN_DEFAULT_LAYOUT = 16;
export const DESIGN_DEFAULT_THEME = 17;
export const HUBSPOT_DEFAULT = 18;
export const HUBSPOT_MARKETPLACE = 19;
export const PROJECT = 21;